import {Pipe, PipeTransform} from '@angular/core';


@Pipe({
  name: 'pedidosFavoritos',
})
export class PedidosFavoritosPipe implements PipeTransform {

  transform(items: any[], filter: any[]) {

    if (filter && items) {

      if (filter['favorito'] || filter['favorito'] == 0) {

        items = items.filter(function (item) {
          return item.favorito == filter['favorito'];
        });
      }
    }

    return items;

  }
}



// WEBPACK FOOTER //
// ./src/pipes/pedidos-favoritos/pedidos-favoritos.ts